import React from 'react';
import { Ellipse, Rect, Star } from 'react-konva';
import { useMapEditor } from '../contexts/MapEditorContext';

export const MapCanvasPreviewShape: React.FC = () => {
  const { previewShape } = useMapEditor();

  if (!previewShape) {
    return null;
  }

  return (
    <>
      {previewShape.type === 'rectangle' && (
        <Rect
          x={previewShape.x}
          y={previewShape.y}
          width={previewShape.width}
          height={previewShape.height}
          stroke="#000"
          strokeWidth={1}
          dash={[5, 5]}
        />
      )}
      {previewShape.type === 'circle' && (
        <Ellipse
          x={previewShape.x}
          y={previewShape.y}
          radiusX={previewShape.width}
          radiusY={previewShape.height}
          //radius={Math.max(previewShape.width, previewShape.height) / 2}
          stroke="#000"
          strokeWidth={1}
          dash={[5, 5]}
        />
      )}
      {previewShape.type === 'star' && (
        <Star
          x={previewShape.x + previewShape.width / 2}
          y={previewShape.y + previewShape.height / 2}
          numPoints={5}
          innerRadius={Math.min(previewShape.width, previewShape.height) / 4}
          outerRadius={Math.min(previewShape.width, previewShape.height) / 2}
          stroke="#000"
          strokeWidth={1}
          dash={[5, 5]}
        />
      )}
    </>
  );
};
